import { render, staticRenderFns } from "./modal_partner_entity_life_record.vue?vue&type=template&id=53838cea"
import script from "./modal_partner_entity_life_record.vue?vue&type=script&lang=js"
export * from "./modal_partner_entity_life_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports